import type { ReactNode } from "react";

const JA_MESSAGES = {
  requiredLabel: "必須回答",
};
export type RequiredAnswerSectionMessages = typeof JA_MESSAGES;

/**
 * 必須回答セクションの共通レイアウトコンポーネント
 *
 * 部屋変更許可や凍結注意事項など、必須回答が必要なセクションで使用する。
 */
export function RequiredAnswerSection({
  title,
  children,
  actionArea,
  messages = JA_MESSAGES,
}: {
  title: string;
  children: ReactNode;
  actionArea: ReactNode;
  messages?: RequiredAnswerSectionMessages;
}) {
  return (
    <div className="bg-swhite mt-[20px] p-[20px] md:p-[40px]">
      <div className="flex flex-col gap-[20px]">
        {/* タイトル行 */}
        <div className="flex items-center gap-[8px]">
          <span className="text-[14px] leading-[1.4] font-bold tracking-[0.28px] md:text-[16px]">
            {title}
          </span>
          <span className="bg-sorange text-swhite flex h-[16px] shrink-0 items-center justify-center rounded-full px-[8px] text-[10px] leading-[1.4] font-bold tracking-[0.2px]">
            {messages.requiredLabel}
          </span>
        </div>
        {/* 本文 */}
        <div className="text-[14px] leading-[1.8] font-medium tracking-[0.56px] md:text-[16px]">
          {children}
        </div>
        {/* アクション */}
        {actionArea}
      </div>
    </div>
  );
}
